import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTable } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { NgxFileDropEntry, FileSystemFileEntry } from "ngx-file-drop";
import { NotificationService } from "src/app/notifications/notification.service";
import { PermissionService } from "src/app/permission.service";
import { SessionService } from "src/app/session.service";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { FilterTableDialogComponent } from "src/app/shared/dialogs/filter-table-dialog/filter-table-dialog.component";
import { UiService } from "src/app/ui/ui.service";
import { Media, MediaService } from "../../media.service";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { BehaviorSubject, merge, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  first,
  map,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { DataSource } from "@angular/cdk/table";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { CollectionViewer } from "@angular/cdk/collections";
import { LocalStorageService } from "src/app/storage/local-storage.service";
import { find } from "lodash";
import { GeneratePreviewComponent } from "../../generate-preview/generate-preview.component";
import { CropComponent } from "../../crop/crop.component";
import { Cloudinary } from "@cloudinary/url-gen";
import { crop } from "@cloudinary/transformation-builder-sdk/actions/resize";
@Component({
  selector: "app-media-library",
  templateUrl: "./media-library.component.html",
  styleUrls: ["./media-library.component.scss"],
})
export class MediaLibraryComponent implements OnInit {
  pageSizeOptions = pageSizeOptions;
  searchValueControl = new FormControl("");
  perPage: number = 20;

  columns = [
    { code: "description", name: "Description", filter: true, selected: true },
    { code: "name", name: "Name", filter: true, selected: true },
    { code: "context", name: "Context" },
    { code: "created_by_name", name: "Created By Name" },
    { code: "options" },
  ];
  displayedColumns = this.columns.map((column) => column.code);

  mediaUploadTypeOptions: Array<{
    name: string;
    code: string;
    supportsGeneration?: boolean;
    isSingle?: boolean;
  }> = [
    {
      name: "Mobile Header",
      code: "signal_template_logo",
    },
    {
      name: "Mobile Background",
      code: "signal_template_background",
    },
    {
      name: "Tripist Logo Image",
      code: "tripist_logo_image",
    },
    {
      name: "Tripist Category Image",
      code: "tripist_category_image",
    },
    {
      name: "Tripist Avatar Image",
      code: "tripist_avatar_image",
    },
    {
      name: "Tripist Item Image",
      code: "tripist_document_image",
    },
    {
      name: "Tripist Hero Image",
      code: "tripist_document_hero_image",
    },
    {
      name: "Explorist Logo Image",
      code: "explorist_logo_image",
    },
    {
      name: "Explorist Category Image",
      code: "explorist_category_image",
    },
    {
      name: "Explorist Avatar Image",
      code: "explorist_avatar_image",
    },
    {
      name: "Explorist Item Image",
      code: "explorist_document_image",
    },
    {
      name: "Explorist Hero Image",
      code: "explorist_document_hero_image",
    },
    {
      name: "Aura Logo Image",
      code: "aura_logo_image",
    },
    {
      name: "Aura Category Image",
      code: "aura_category_image",
    },
    {
      name: "Aura Avatar Image",
      code: "aura_avatar_image",
    },
    {
      name: "Aura Item Image",
      code: "aura_document_image",
    },
    {
      name: "Aura Hero Image",
      code: "aura_document_hero_image",
    },
    {
      name: "Luma Preview Logo",
      code: "luma_preview_logo",
      supportsGeneration: false,
      isSingle: true,
    },
    // {
    //   name: "Email Header",
    //   code: "email_header",
    // },
    // {
    //   name: "Email Thumbnail",
    //   code: "email_thumbnail",
    // },
  ];

  imageGenerationOptions = this.mediaUploadTypeOptions.filter(
    (option) => option.supportsGeneration !== false,
  );

  get singleUseTypes(): string[] {
    return this.mediaUploadTypeOptions
      .filter((option) => option.isSingle)
      .map((option) => option.code);
  }

  uploadMediaForm = new FormGroup({
    mediaUploadType: new FormControl(""),
    desc: new FormControl("", [Validators.required]),
  });
  file: File | undefined;
  filePreviewUrl: string | null = null;
  imageWidth: number | undefined;
  imageHeight: number | undefined;
  medias!: Media[];
  @ViewChild("mediaTable") mediaTable!: MatTable<Media[]>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  currentMedia: Media | null = null;
  currentWidth: number | null = null;
  currentHeight: number | null = null;
  isPreview: boolean = false;
  showCreateAndEdit: boolean = false;
  showRemove: boolean = false;
  private onComponentDestroy = new Subject();
  @ViewChild(ElementLoaderDirective)
  mediaElementLoader!: ElementLoaderDirective;
  mediasDataSource!: MediasDataSource;
  onFilterColumnChange = new Subject();

  imageGenForm = new FormGroup({
    mediaUploadType: new FormControl(""),
    name: new FormControl("", [Validators.required]),
    desc: new FormControl("", [Validators.required]),
  });
  imageGenIntegration: any;

  constructor(
    private MediaService: MediaService,
    private SessionService: SessionService,
    private route: ActivatedRoute,
    private NotificationService: NotificationService,
    private Dialog: MatDialog,
    private PermissionService: PermissionService,
    private uiService: UiService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private localStorageSvc: LocalStorageService,
  ) {}

  ngOnInit(): void {
    // this.medias = this.route.snapshot.data.medias.records;
    // this.mediaDataSource = new MatTableDataSource(this.medias);

    // this.mediaDataSource.filterPredicate = (data: any, filter: string) => {
    //   for (let selectedColumn of this.selectedColumns) {
    //     if (data[selectedColumn]?.toString().toLowerCase().includes(filter)) {
    //       return true;
    //     }
    //   }
    //   return false;
    // };

    this.imageGenIntegration = find(this.route.snapshot.data.integrations, (integration: any) => integration.provider.type === 'image_assistant');

    this.perPage = this.localStorageSvc.pageSize || 20;

    Promise.all([
      this.PermissionService.categories.media.hasCreate(),
      this.PermissionService.categories.media.hasRemove(),
    ]).then(([hasCreate, hasRemove]) => {
      this.showCreateAndEdit = hasCreate;
      this.showRemove = hasRemove;

      if (!this.showCreateAndEdit) {
        this.uploadMediaForm.disable();
      }
    });
  }

  ngAfterViewInit() {
    this.mediasDataSource = new MediasDataSource(
      this.MediaService,
      this.paginator,
      this.mediaElementLoader,
    );

    this.loadMediasPage().pipe(first()).subscribe();

    merge(
      this.sort.sortChange.pipe(tap(() => (this.paginator.pageIndex = 0))),
      this.paginator.page,
      this.onFilterColumnChange,
      this.searchValueControl.valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => (this.paginator.pageIndex = 0)),
      ),
    )
      .pipe(
        debounceTime(300),
        switchMap(() => this.loadMediasPage().pipe(first())),
        takeUntil(this.onComponentDestroy),
      )
      .subscribe();

    this.ChangeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  // initMediaTable() {
  //   this.mediaTable.renderRows();
  //   this.mediaDataSource.sort = this.sort;
  //   this.mediaDataSource.paginator = this.paginator;
  // }

  optimalWidth(form: FormGroup) {
    let type = this.mediaUploadType(form);
    if (type === "signal_template_logo") {
      return 430;
    }
    if (type === "signal_template_background") {
      return 430;
    }
    if (type === "email_header") {
      return 430;
    }
    if (type === "email_thumbnail") {
      return 430;
    }
    return null;
  }

  optimalHeight(form: FormGroup) {
    let type = this.mediaUploadType(form);
    if (type === "signal_template_logo") {
      return 130;
    }
    if (type === "signal_template_background") {
      return 675;
    }
    if (type === "email_header") {
      return 130;
    }
    if (type === "email_thumbnail") {
      return 675;
    }
    return null;
  }

  mediaUploadType(form: FormGroup) {
    return form.controls.mediaUploadType.value;
  }

  get uploadDisabled() {
    if (this.uploadMediaForm.invalid || !this.file) {
      return true;
    }

    if (this.singleUseTypeAlreadyExists) {
      return true;
    }

    return false;
  }

  get singleUseTypeAlreadyExists(): boolean {
    return this.singleUseTypes.includes(this.type) && this.hasExistingSingleUse(this.type);
  }

  get editDisabled() {
    if (this.uploadMediaForm.invalid) {
      return true;
    }

    if (
      this.currentMedia &&
      this.singleUseTypes.includes(this.type) &&
      this.hasExistingSingleUse(this.type, this.currentMedia.id)
    ) {
      return true;
    }

    return false;
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue!;
  }

  get description() {
    return this.uploadMediaForm.controls.desc.value;
  }

  get type() {
    return this.uploadMediaForm.controls.mediaUploadType.value;
  }

  get typeName() {
    return this.getMediaType(this.type) ?? this.type;
  }

  get isEdit() {
    return !!this.currentMedia;
  }

  // applyFilter() {
  //   this.mediaDataSource.filter = this.searchValue.trim().toLowerCase();
  // }

  toggleFilterDialog() {
    this.Dialog.open(FilterTableDialogComponent, {
      data: {
        columns: this.columns,
      },
    })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.columns = result;
          this.onFilterColumnChange.next();
        }
      });
  }

  dropped(files: NgxFileDropEntry[]) {
    for (const droppedFile of files) {
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.file = file;
          this.ChangeDetectorRef.detectChanges();
          const reader = new FileReader();

          reader.readAsDataURL(file);

          reader.onload = (e) => {
            const image = new Image();
            const result = e.target?.result;
            if (typeof result === "string") {
              this.filePreviewUrl = result;
              image.src = result;
            } else {
              this.filePreviewUrl = null;
              image.src = "";
            }

            image.onload = () => {
              this.imageWidth = image.width;
              this.imageHeight = image.height;
              this.ChangeDetectorRef.detectChanges();
            };

            this.ChangeDetectorRef.detectChanges();
          };
        });
      }
    }
  }

  cancel() {
    this.uploadMediaForm.controls.mediaUploadType.setValue(null);
    this.uploadMediaForm.controls.desc.setValue(null);
    this.uploadMediaForm.controls.desc.markAsUntouched();
    this.uploadMediaForm.controls.mediaUploadType.markAsUntouched();
    this.currentMedia = null;
    this.isPreview = false;
    this.removeFile();
  }

  removeFile() {
    this.file = undefined;
    this.imageHeight = undefined;
    this.imageWidth = undefined;
    this.filePreviewUrl = null;
  }

  uploadImage() {
    this.guardSingleUseAndExecute(this.type, null, () => {
      this.uiService
        .waitForEvent(
          this.MediaService.postMedia(
            this.currentAccount.accountID,
            this.file!,
            this.mediaUploadType(this.uploadMediaForm),
            this.description,
          ),
        )
        .pipe(takeUntil(this.onComponentDestroy))
        .subscribe(
          () => {
            this.NotificationService.openSuccessSnackBar("Media uploaded");
            this.loadMediasPage().pipe(first()).subscribe();
            this.cancel();
          },
          () => {
            this.NotificationService.openErrorSnackBar("Error uploading media");
          },
        );
    });
  }

  // reinitMedias() {
  //   this.uiService
  //     .waitForEvent(
  //       this.MediaService.getMedias(this.currentAccount.accountID, {
  //         page: 0,
  //         perPage: 999999999,
  //       }),
  //     )
  //     .pipe(takeUntil(this.onComponentDestroy))
  //     .subscribe((medias) => {
  //       this.medias = medias.records as unknown as Media[];
  //       this.mediaDataSource = new MatTableDataSource(this.medias);
  //       this.initMediaTable();
  //     });
  // }

  getMediaType(type: string) {
    return this.mediaUploadTypeOptions.find((option) => {
      return option.code === type;
    })?.name;
  }

  viewMedia(media: Media) {
    this.isPreview = true;
    this.removeFile();
    this.currentMedia = media;

    this.uploadMediaForm.controls.desc.setValue(media.description);
    this.uploadMediaForm.controls.mediaUploadType.setValue(media.context);

    this.loadDimensionsFromUrl(media.url);
  }

  editMedia(media: Media) {
    this.isPreview = false;
    this.removeFile();
    this.currentMedia = media;
    this.uploadMediaForm.controls.desc.setValue(media.description);
    this.uploadMediaForm.controls.mediaUploadType.setValue(media.context);

    this.loadDimensionsFromUrl(media.url);
  }

  updateMedia() {
    this.guardSingleUseAndExecute(this.type, this.currentMedia?.id ?? null, () => {
      this.uiService
        .waitForEvent(
          this.MediaService.updateMedia(this.currentAccount.accountID, {
            ...this.currentMedia!,
            description: this.uploadMediaForm.controls.desc.value,
            context: this.uploadMediaForm.controls.mediaUploadType.value,
          }, this.file),
        )
        .pipe(takeUntil(this.onComponentDestroy))
        .subscribe(
          (updated) => {
            this.NotificationService.openSuccessSnackBar("Media updated");
            if (updated && this.currentMedia) {
              this.currentMedia = {
                ...this.currentMedia,
                ...updated,
              } as Media;
              this.removeFile();
              this.loadDimensionsFromUrl(this.currentMedia.url);
            } else {
              this.removeFile();
            }
            this.loadMediasPage().pipe(first()).subscribe();
          },
          () => {
            this.NotificationService.openErrorSnackBar("Error updating media");
          },
        );
    });
  }

  private loadDimensionsFromUrl(url?: string | null) {
    if (!url) {
      this.currentHeight = null;
      this.currentWidth = null;
      return;
    }

    const img = new Image();
    img.onload = () => {
      this.currentHeight = img.height;
      this.currentWidth = img.width;
    };

    img.src = url;
  }

  private hasExistingSingleUse(typeCode: string, excludeId?: number | null): boolean {
    const records = this.mediasDataSource?.latestRecords ?? [];

    return records.some((media: Media) => {
      if (media.context !== typeCode) {
        return false;
      }
      if (excludeId && media.id === excludeId) {
        return false;
      }
      return true;
    });
  }

  private guardSingleUseAndExecute(
    typeCode: string | null,
    excludeId: number | null,
    action: () => void,
  ): void {
    if (!typeCode || !this.singleUseTypes.includes(typeCode)) {
      action();
      return;
    }

    const code = typeCode;

    if (this.hasExistingSingleUse(code, excludeId)) {
      this.NotificationService.openErrorSnackBar("Only one Luma Preview Logo can be uploaded per account");
      return;
    }

    this.ensureSingleUseAvailable(code, excludeId)
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((available) => {
        if (!available) {
          this.NotificationService.openErrorSnackBar("Only one Luma Preview Logo can be uploaded per account");
          return;
        }
        action();
      });
  }

  private ensureSingleUseAvailable(
    typeCode: string,
    excludeId: number | null,
  ): Observable<boolean> {
    return this.MediaService.getMedias(this.currentAccount.accountID, {
      page: 0,
      perPage: 2,
      context: typeCode,
      forCount: false,
    }).pipe(
      first(),
      map((response: any) => {
        const records: Media[] = Array.isArray(response?.records)
          ? response.records
          : Array.isArray(response)
          ? response
          : [];

        return !records.some((media) => {
          if (media.context !== typeCode) {
            return false;
          }
          if (excludeId && media.id === excludeId) {
            return false;
          }
          return true;
        });
      }),
      catchError(() => of(false)),
    );
  }

  deleteMedia(media: Media) {
    this.Dialog.open(AreYouSureDialogComponent, {
      data: {
        areYouSureInfo: {
          description: `This media will be permanantly deleted`,
        },
      },
    })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((res) => {
        if (res) {
          this.uiService
            .waitForEvent(
              this.MediaService.deleteMedia(
                this.currentAccount.accountID,
                media.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.NotificationService.openSuccessSnackBar("Media deleted");

                // this.reinitMedias();
                this.loadMediasPage().pipe(first()).subscribe();
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting media",
                );
              },
            );
        }
      });
  }

  loadMediasPage() {
    const sort = this.buildSort();

    return this.mediasDataSource.loadMedias(
      this.SessionService.currentAccountValue!.accountID,
      {
        page: this.paginator.pageIndex,
        perPage: this.paginator.pageSize,
        keyword: this.searchValueControl.value ?? "",
        forCount: true,
        sort,
        filter_columns: this.columns
          .filter((column) => column.selected)
          .map((column) => column.code),
      },
    );
  }

  buildSort() {
    const sort = [];
    if (this.sort.direction.length) {
      sort.push(`${this.sort.active}:${this.sort.direction}`);
    }
    return sort;
  }

  onPageChange(e: PageEvent){
    this.paginator.pageSize = e.pageSize;
    this.localStorageSvc.pageSize = e.pageSize;
  }

  base64ToFile(base64String: String, filename: string) {
      // Split the base64 string in data and contentType
      const splitString = base64String.split(',');
      const contentType = splitString[0].match(/:(.*?);/)![1];
      const base64Data = splitString[1];

      // Convert base64 to raw binary data held in a string
      const byteCharacters = atob(base64Data);

      // Convert that text into a byte array
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      // Convert the byte array to a Blob
      const byteArray = new Uint8Array(byteNumbers);
      const fileBlob = new Blob([byteArray], {type: contentType});

      // Create a File from Blob
      const file = new File([fileBlob], filename, {type: contentType});

      return file;
  }

  generateImage() {
    if(!this.imageGenForm!.valid){
      return;
    }

    const dialogRef = this.Dialog.open(GeneratePreviewComponent, {
      width: "560px",
      height: "615px",
      data: {
        integrationId: this.imageGenIntegration.id,
        type: this.mediaUploadType(this.imageGenForm),
        name: this.imageGenForm.controls.name.value,
        width: this.optimalWidth(this.imageGenForm),
        height: this.optimalHeight(this.imageGenForm),
        prompt: this.imageGenForm.controls.desc.value,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if(result.error){
          this.NotificationService.openErrorSnackBar('Error generating image: '+ result.error.message);
        } else {
          const cropRef = this.Dialog.open(CropComponent, {
            width: "560px",
            height: "605px",
            data: {
              image: result,
              type: this.imageGenForm.value.mediaUploadType,
            },
          });
          cropRef.afterClosed().subscribe((result) => {
            if (result) {
              this.uiService
                .waitForEvent(
                  this.MediaService.postMedia(
                    this.currentAccount.accountID,
                    this.base64ToFile(result.croppedImage.base64, this.imageGenForm.value.name),
                    this.imageGenForm.value.mediaUploadType,
                    this.imageGenForm.value.name,
                  ),
                )
                .pipe(takeUntil(this.onComponentDestroy))
                .subscribe(
                  (res) => {
                    this.NotificationService.openSuccessSnackBar("Media uploaded");
                    this.loadMediasPage().pipe(first()).subscribe();
                    this.imageGenForm.reset();
                  },
                  () => {
                    this.NotificationService.openErrorSnackBar("Error uploading media");
                  },
                );
            }
          });
        }
      }
    });
  }
}

export class MediasDataSource implements DataSource<any> {
  private mediasSubject = new BehaviorSubject<any[]>([]);
  latestRecords: Media[] = [];

  constructor(
    private MediaService: MediaService,
    private paginator: MatPaginator,
    private mediasElementLoader: ElementLoaderDirective,
  ) {}

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.mediasSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.mediasSubject.complete();
  }

  loadMedias(masterAccountID: number, queryParams: any) {
    return this.mediasElementLoader
      .waitForEvent(
        this.MediaService.getMedias(masterAccountID, queryParams).pipe(
          catchError(() => of({ count: 0, records: [] })),
        ),
      )
      .pipe(
        tap((filter: any) => {
          this.paginator.length = filter.count;
          this.mediasSubject.next(filter.records);
          this.latestRecords = filter.records || [];
        }),
      );
  }

}
